import * as React from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate, Link } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";

import AuthLayout from "../AuthLayout";
import { AuthError } from "../../utils/errors";
import { requestPasswordReset } from "../../api/auth";
import { useTranslation } from "react-i18next";

function RequestPasswordResetPage() {
  const { t } = useTranslation(["user", "auth"]);
  const { setLastUserId } = useAuthContext();
  const navigate = useNavigate();

  const [email, setEmail] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      await requestPasswordReset(email);
      setLastUserId(email);
      navigate("/reset_password/confirm");
    } catch (error) {
      if (error instanceof AuthError) {
        setErrorMessage(error.details);
      }
      console.error(error.message);
    }
  }

  const body = (
    <Form onSubmit={handleSubmit}>
      <Form.Group controlId="email" className="mb-3">
        <Form.Label>{t("user:email")}</Form.Label>
        <Form.Control
          type="email"
          autoFocus={true}
          autoComplete="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          required
          isInvalid={!!errorMessage}
        />
        <Form.Control.Feedback type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>
      <Button variant="primary" type="submit" className="w-100">
        {t("auth:sendResetInstructions")}
      </Button>
    </Form>
  );

  const links = (
    <React.Fragment>
      <Link to="/sign_in">{t("auth:signIn")}</Link>
      <Link to="/sign_up">{t("auth:signUp")}</Link>
      <Link to="/sign_up/resend_confirmation_email">
        {t("auth:resendConfirmationEmailLink")}
      </Link>
    </React.Fragment>
  );

  return (
    <AuthLayout
      title={t("auth:forgotPasswordLink")}
      body={body}
      footer={links}
    />
  );
}

export default RequestPasswordResetPage;
